import upload from './upload'
import validate from './validate'

export default {
    upload,
    validate,
}